/**
 * Dropdown Edge-Flip für die Desktop-Header-Navigation.
 *
 * Problem: Top-Level-.DropdownMenu ist absolut positioniert (linksbündig am
 * Menüpunkt) ohne Viewport-Kollisionserkennung. Bei Menüpunkten nahe am
 * rechten Viewport-Rand läuft das Dropdown aus dem sichtbaren Bereich.
 *
 * Lösung: MutationObserver auf das aria-hidden-Attribut der .DropdownMenu
 * (theme.js toggelt aria-hidden=true/false beim Öffnen/Schließen — es gibt
 * kein <details>/toggle-Event wie im neueren Prestige). Beim Öffnen wird
 * gemessen und das Dropdown bei Überlauf per translate nach links geschoben.
 *
 * Verschachtelte Flyouts (.DropdownMenu .DropdownMenu) werden NICHT behandelt:
 * theme.js (_adjustDropdownPosition) setzt dort bereits DropdownMenu--reversed
 * bei Überlauf. Dieses Script würde mit derselben Klasse kollidieren.
 *
 * Portiert aus dem Relaunch-Theme (assets/mm-dropdown-edge-flip.js dort,
 * docs/41-header-dropdown-edge-flip.md), Trigger von toggle-Event auf
 * MutationObserver umgebaut.
 */
(function () {
  var EDGE_GAP = 8; // px Mindestabstand zum Viewport-Rand

  function isTopLevel(menu) {
    return !menu.parentElement.closest('.DropdownMenu');
  }

  function adjust(menu) {
    // Reset, damit Messung und erneutes Öffnen sauber starten
    menu.style.translate = '';

    if (menu.getAttribute('aria-hidden') !== 'false') return;

    var rect = menu.getBoundingClientRect();
    if (rect.width === 0) return; // nicht gerendert (z.B. Mobile)

    var overflow = rect.right - (window.innerWidth - EDGE_GAP);
    if (overflow <= 0) return;

    menu.style.translate = -overflow + 'px';
  }

  function onMutation(mutations) {
    mutations.forEach(function (mutation) {
      var menu = mutation.target;
      if (!menu.classList || !menu.classList.contains('DropdownMenu')) return;
      if (!isTopLevel(menu)) return;
      requestAnimationFrame(function () { adjust(menu); });
    });
  }

  function init() {
    var navs = document.querySelectorAll('.Header__MainNav');
    if (!navs.length) return;

    var observer = new MutationObserver(onMutation);
    navs.forEach(function (nav) {
      observer.observe(nav, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
        subtree: true,
      });
    });

    // Offene Dropdowns bei Resize nachjustieren
    window.addEventListener('resize', function () {
      document.querySelectorAll(
        '.Header__MainNav .DropdownMenu[aria-hidden="false"]'
      ).forEach(function (menu) {
        if (isTopLevel(menu)) adjust(menu);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
